import { hot } from "react-hot-loader";

import React from "react";

import { useFeatureFlags } from "src/shared/components/FeatureFlags";
import { withDrawerContextProvider } from "src/shared/contact-boxes/experts/utilities/drawerHelpers";
import useActiveExperts from "src/shared/contact-boxes/experts/utilities/hooks/useActiveExperts";
import useAbTests from "src/shared/utilities/useAbTests";

import DrawerForm from "../DrawerForm";

// TODO fossa_1638_experts_contact_box_refactor cleanup: remove mobileExpertsForm sub-feature
export const MobileFormButtonHdp = () => {
  const { flags } = useFeatureFlags(
    ["fossa_1638_experts_contact_box_refactor"],
    true
  );
  const {
    fossa_1638_experts_contact_box_refactor: abTestVariant,
    loading: abTestsLoading
  } = useAbTests("fossa_1638_experts_contact_box_refactor");

  const showNewVariant =
    flags?.fossa_1638_experts_contact_box_refactor && abTestVariant === "new";

  const { data, loading } = useActiveExperts();

  if (!flags || abTestsLoading || showNewVariant || loading || !data) {
    return null;
  }

  return <DrawerForm isMobile />;
};

export default hot(module)(
  withDrawerContextProvider(MobileFormButtonHdp, true)
);
